import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ['playIcon', 'videoElement']

  play() {
    this.videoElementTarget.play()
    this.playIconTarget.remove()
  }
}